import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { useRealtimeDrivers } from 'Core/hooks';
import { Input, Button, Select, GlobalAlert, Tooltip, Loading, Pill, Checkbox } from 'Components';
import {
    Grid, ListItemIcon, ListItemText, Divider, ListItem, Avatar, Typography, IconButton, Menu, MenuItem
} from "@mui/material";
import MessageIcon from '@mui/icons-material/Message';
import InputSearch from 'Components/InputSearch';
import './index.scss';
//Views
import Message from './components/message';
import { NotificationManager } from 'Components/Notifications';
import FsmAvatarDriver from '../main/components/avatarDriver';

// Styles
import styles from "Assets/sass/core/vars.scss";
import {
    searchQuickMessage,
    searchMessage,
    createMessage,
    createMessageAll,
    getAllowDriverToDriver,
    updateAllowDriverToDriver,
    clearRedux
} from 'Redux/actions';
import { getLastConnection } from '../main/tools/getLastConn';

const FsmMessages = (props) => {

    const { messages, locale } = useIntl();
    const messagesReference = useRef(null);
    const optionsFilterDrivers = [{ id: 'all', name: messages['FSM_SETTINGS_MESSAGES_DRIVER_ALL'] }, { id: 'connected', name: messages['FSM_SETTINGS_MESSAGES_DRIVER_CONNECTED'] }]

    const [listMessages, setListMessages] = useState([]);
    const [visibleAlert, setVisibleAlert] = useState(false);
    const [anchorDashboard, setAnchorDashboard] = useState(null);
    const [listQuickMessages, setListQuickMessages] = useState([]);
    const [lisDrivers, setLisDrivers] = useState([]);
    const [messageText, setMessageText] = useState('');

    const [filterConnected, setFilterConnected] = useState(optionsFilterDrivers[0]);
    const [driverSelected, setDriverSelected] = useState({});
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState('');
    const [allowFsmDriver, setAllowFsmDriver] = useState(false);

    //get the information for drivers from catalog
    const allDrivers = useRealtimeDrivers({ trackFields: ['id', 'name', 'externalId', 'disabled', 'tags'] });

    const TimeCardDrivers = useMemo(() => {
        return allDrivers?.filter(driver => driver.fsmDriver === true) || [];   
    }, [allDrivers]);

    
    const loadingTimeCardDrivers = useSelector(state => state.catalogsRedux.loadingDrivers);

    const {
        quickMData
    } = useSelector(state => state.quickMessageRedux);

    const {
        loadingMessage,
        Messages,
        loadingCreateEdit,
        response,
        allowDrivertoDriver
    } = useSelector(state => state.MessagesRedux);


    const fsmNomadPushNotification = useSelector(state => state.catalogsRedux.fsmNomadPushNotification);

    const { user: { dateformat } } = useSelector((state) => state.securityRedux);
    useEffect(() => {
        if (fsmNomadPushNotification && fsmNomadPushNotification?.Entity==="nomadChatMessage") {
            
            if(fsmNomadPushNotification?.Data?.data[0]?.from_driver_id==driverSelected?.driverId){
                dispatch(searchMessage(driverSelected?.driverId,true))
            }
        }
    }, [fsmNomadPushNotification]);



    useEffect(() => {
        if (quickMData.length > 0) {
            setListQuickMessages(quickMData)
        }
    }, [quickMData]);

    useEffect(() => {
        if (TimeCardDrivers?.length > 0) {
            setLisDrivers(TimeCardDrivers)
        }
    }, [TimeCardDrivers]);

    useEffect(() => {
        dispatch(clearRedux("FSM_SETTINGS_MESSAGE", {
            loadingMessage: false,
            Messages: {},
            loadingCreateEdit: false,
            response: {}
        }))
        dispatch(searchQuickMessage());
        dispatch(getAllowDriverToDriver());
    }, []);

    useEffect(() => {
        setListMessages(Messages?.items);
    }, [Messages]);

    useEffect(() => {
        if (allowDrivertoDriver?.fsmAllChat) {
            setAllowFsmDriver(true)
        }
    }, [allowDrivertoDriver]);



    useEffect(() => {
        const offsetBottom = messagesReference.current.offsetTop + messagesReference.current.offsetHeight + 3000;
        messagesReference.current.scrollTo(0, offsetBottom);
    }, [listMessages]);



    useEffect(() => {
        if (!response.error && response?.create?.createFsmDriverMessage) {
            NotificationManager.success(
                messages['FSM_SETTINGS_MESSAGES_CREATED'],
                messages['success'],
                3000,
                null,
                null,
                'Success',
            );
            setListMessages([...listMessages, response?.create?.createFsmDriverMessage])
            dispatch(clearRedux("FSM_SETTINGS_MESSAGE", {
                response: {}
            }));
        }

        if (!response.error && response?.create?.createFsmDriverAllMessage) {
            setListMessages([...listMessages, response?.create?.createFsmDriverAllMessage])

            NotificationManager.success(
                messages['FSM_SETTINGS_MESSAGES_CREATED'],
                messages['success'],
                3000,
                null,
                null,
                'Success',
            );
            dispatch(clearRedux("FSM_SETTINGS_MESSAGE", {
                response: {}
            }));
        }

    }, [response]);


    const handleSearch = (text) => {
        setSearchText(text)
        let newFilter = TimeCardDrivers?.filter((item) => item.name.toLowerCase().includes(text.toLowerCase()))

        if (filterConnected?.id && filterConnected?.id === 'connected') {
            newFilter = newFilter?.filter((item) => item.connected == 1)
        }

        setLisDrivers(newFilter)
    };


    useEffect(() => {
        handleSearch(searchText)
    }, [filterConnected]);


    const handleKeyDown = (e) => {
        if (e.key !== "Enter" || messageText == '')
            return false;

        dispatch(createMessage({
            message: messageText,
            driverId: driverSelected?.driverId
        }));

        setMessageText('');
    };

    return (
        <div>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                style={{ height: "calc(100vh - 100px)", marginTop: -24 }}
            >
                <Grid item xs={8} style={{ height: '100%' }} >
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                        style={{ height: '100%' }}
                    >
                        <Grid item xs={12} className="contaier_messages">
                            {driverSelected?.name &&
                                <FsmAvatarDriver driver={driverSelected} />
                            }
                            <div className="container_messages_messages" ref={messagesReference} >
                                {loadingMessage && <Loading style={{ marginTop: 15 }} />}

                                {
                                    listMessages?.length > 0 && listMessages?.map((mRow, i) => {
                                        return (
                                            <div style={{ width: '100%', display: 'inline-block' }} key={i}>
                                                <Message message={mRow} />
                                            </div>
                                        )
                                    })
                                }
                            </div>

                        </Grid>
                        <Grid item xs={12} className="contaier_input">
                            <Grid
                                container
                                direction="row"
                                justifyContent="flex-start"
                                alignItems="center"
                            >
                                <Grid item xs={1} style={{ textAlign: 'center' }}>
                                    <Tooltip title={messages['FSM_SETTINGS_QUICK_MESSAGE']} placement={'top'}>
                                        <IconButton
                                            className="flexCenter"
                                            disabled={!driverSelected?.driverId}
                                            style={{ marginTop: 30 }}
                                            onClick={(event) => setAnchorDashboard(event.currentTarget)}
                                            size="large">
                                            <MessageIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Menu
                                        elevation={0}
                                        anchorEl={anchorDashboard}
                                        open={Boolean(anchorDashboard)}
                                        onClose={() => setAnchorDashboard(null)}
                                        className="menu-user"
                                        //getContentAnchorEl={null}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        transformOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                        }}
                                    >
                                        {
                                            listQuickMessages?.length > 0 && listQuickMessages?.map((row, i) => {
                                                return (
                                                    <MenuItem
                                                        onClick={(c) => {
                                                            setMessageText(row?.name);
                                                            setAnchorDashboard(null);
                                                        }}
                                                        key={i}
                                                    >
                                                        <ListItemText primary={row?.name} className={`listMenuItem`} />
                                                    </MenuItem>
                                                )
                                            })
                                        }
                                    </Menu>
                                </Grid>

                                <Grid item xs={7} style={{ marginTop: -10 }} >
                                    <Input
                                        id="title"
                                        type="text"
                                        placeholder={messages['FSM_SETTINGS_MESSAGES_WRITE_MESSAGE']}
                                        value={messageText}
                                        disabled={!driverSelected?.driverId}
                                        onChange={(value) => {
                                            setMessageText(value)
                                        }}
                                        maxLength={500}
                                        onKeyDown={handleKeyDown}
                                    />
                                    <Typography variant="body2" color="textSecondary" style={{ fontSize: 11, textAlign: 'right', paddingTop: 5 }}>
                                        {messages['FSM_SETTINGS_MESSAGES_CHARACTERS']} {messageText?.length}/500
                                    </Typography>
                                </Grid>
                                <Grid item xs={4} >
                                    {loadingCreateEdit &&
                                        <Loading />
                                    }
                                    {!loadingCreateEdit &&
                                        <>
                                            <Button
                                                onClick={() => {
                                                    if (messageText !== '') {
                                                        dispatch(createMessage({
                                                            message: messageText,
                                                            driverId: driverSelected?.driverId
                                                        }));
                                                        setMessageText('')

                                                    }

                                                }}
                                                disabled={!driverSelected?.driverId}
                                                className="btn-blue"
                                            >
                                                {messages['FSM_SETTINGS_MESSAGES_SEND']}

                                            </Button>
                                            <Button
                                                className="btn-blue"
                                                disabled={!driverSelected?.driverId}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (messageText.length > 0)
                                                        setVisibleAlert(true);

                                                }}
                                            >
                                                {messages['FSM_SETTINGS_MESSAGES_SEND_ALL']}
                                            </Button>
                                        </>
                                    }
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
                <Grid item xs={4} style={{ height: '100%' }} >
                    <div style={{ padding: 24 }}>

                        <Typography style={{ fontWeight: 'bold', marginBottom: 5 }} variant="subtitle1">
                            {messages['FSM_SETTINGS_MESSAGES_FSM_DRIVER']}
                        </Typography>
                        <InputSearch
                            id="search-fsm-messages"
                            searchText={searchText}
                            onSearch={handleSearch}
                            placeholder={messages['search']}
                            className="search-fsm-messages"
                        />
                        <Select
                            id="search-fsm-messages"
                            value={filterConnected}
                            onChange={(event) => {
                                setFilterConnected(event);
                            }}
                            options={optionsFilterDrivers}
                            textField="name"
                            valueField="id"
                            placeholder={`placeholder`}
                        />
                        <Checkbox
                            id={'-selectAll'}
                            value={allowFsmDriver}
                            style={{marginTop:10}}
                            className='checkAllowDriver'
                            label={messages['FSM_SETTINGS_MESSAGES_ALLOW_DRIVER_DRIVER']}
                            onChange={(checked) => {
                                setAllowFsmDriver(checked);
                                dispatch(updateAllowDriverToDriver({
                                    action:checked?1:0
                                }))
                            }}
                        />
                        <div style={{ height: "calc(100vh - 420px)", overflow: 'auto', textAlign: 'center', marginTop: 10 }}>
                            {loadingTimeCardDrivers && <Loading style={{ marginTop: 15 }} />}

                            {
                                lisDrivers?.length > 0 && lisDrivers?.map((row, index) => {
                                    let color = (row?.connected) ? 'fsmAvatarConnected' : '';
                                    const lastConn = getLastConnection(row, dateformat, messages, locale)                                    

                                    return (
                                        <div key={`fsmItem_${index}`}>
                                            <ListItem
                                                className='fsmDriverItem'
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    dispatch(searchMessage(row?.driverId))
                                                    setDriverSelected(row)
                                                }}
                                            >
                                                <ListItemIcon>
                                                    <Avatar aria-label="recipe" className={color}>
                                                        {row?.name[0].toUpperCase()}
                                                    </Avatar>
                                                </ListItemIcon>
                                                <ListItemText >
                                                    <Typography color="inherit"  >
                                                        {row?.name}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary" style={{ fontSize: 12 }}>
                                                        {messages['FSM_SETTINGS_MESSAGES_LAST_CONNECTION']}: { lastConn}
                                                    </Typography>
                                                    <Typography variant="body2" color="textSecondary" style={{ fontSize: 12 }}>
                                                        {messages['FSM_SETTINGS_MESSAGES_UNIT']}  {row?.unit?.label}
                                                    </Typography>
                                                </ListItemText>
                                            </ListItem>
                                            <Divider />
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div style={{ height: 70, padding: 5, fontWeight: 'Bold' }}>
                            {messages['FSM_SETTINGS_MESSAGES_LEGEN']}

                            <Pill key={`pill-1`} style={{ margin: 5 }} item={{
                                name: messages['FSM_SETTINGS_MESSAGES_STATUS_NOT_CONNECTED'],
                                color: styles.color_primary
                            }} />

                            <Pill key={`pill-2`} style={{ margin: 5 }} item={{
                                name: messages['FSM_SETTINGS_MESSAGES_STATUS_CONNECTED'],
                                color: styles.green
                            }} />

                            <Pill key={`pill-3`} style={{ margin: 5 }} item={{
                                name: messages['FSM_SETTINGS_MESSAGES_STATUS_CLOCKED'],
                                color: styles.blue
                            }} />

                            <Pill key={`pill-4`} style={{ margin: 5 }} item={{
                                name: messages['FSM_SETTINGS_MESSAGES_STATUS_CLOCKED_CONNECTED'],
                                color: styles.color_icon_tab
                            }} />

                        </div>
                    </div>

                </Grid>
            </Grid>
            {visibleAlert && (
                <GlobalAlert
                    title={messages[`FSM_SETTINGS_MESSAGES_CONFIRM_TITLE`]}
                    contentText={messages[`FSM_SETTINGS_MESSAGES_CONFIRM_CONTENT`]}
                    confirmText={messages[`FSM_SETTINGS_MESSAGES_CONFIRM`]}
                    cancelText={messages[`cancel`]}
                    type='success'
                    onClose={() => setVisibleAlert(false)}
                    onClick={() => {
                        setVisibleAlert(false)

                        let drivers = []
                        TimeCardDrivers?.map((driver) => {
                            if (driver.driverId !== driverSelected?.driverId)
                                drivers.push(driver.driverId)
                        });

                        drivers.push(driverSelected?.driverId);

                        dispatch(createMessageAll({
                            message: messageText,
                            drivers
                        }));
                        setMessageText('')
                    }}
                />
            )}

        </div>
    );
}

export default FsmMessages;